import React from 'react'
import PropTypes from 'prop-types'
import Content from 'components/ContentDetail'
import moment from 'moment'
import { thousandSeparator } from 'utils/NumeralFormat'

import Styles from './index.scss'

const TabQuotationPO = props => (
  <section className={`section-tab ${Styles['section-po']}`}>
    <div className={`content ${Styles['border-content']} ${Styles['left-content']}`}>
      <div className={Styles['left-content-item']}>
        {props.quotationContent.length > 0 ? (
          <Content title="Quotation" data={props.quotationContent} />
        ) : (
          <div className={Styles['empty-po']}>
            <span className={Styles['text-empty']}>There is no quotation yet</span>
          </div>
        )}
      </div>
    </div>
    <div className={Styles.rightSideContainer}>
      <div className={`content ${Styles['border-content']} ${Styles['po-container']}`}>
        <div className={`${Styles['po-title']}`}>
          <h4 className={`${Styles['title-label']}`}>Purchase Order</h4>
          {props.poData && props.poData.url && (
            <a
              className={`${Styles['title-button']}`}
              href={props.poData.url}
              rel="noopener noreferrer"
              target="_blank"
            >
              <i className={`material-icons ${Styles['icon-button']}`}>
                check_circle_outline
              </i>
              VIEW
            </a>
          )}
        </div>
        {props.poData && props.poData.url ? (
          <div className={`${Styles['po-info']}`}>
            <div className={`${Styles['po-item']}`}>
              <span className={`${Styles['po-label']}`}>Submitted By</span>
              <span className={`${Styles['po-value']}`}>
                {props.poData.submittedBy.firstName}
              </span>
            </div>
            {props.poData.reviewedBy && (
              <div className={`${Styles['po-item']}`}>
                <span className={`${Styles['po-label']}`}>Reviewed By</span>
                <span className={`${Styles['po-value']}`}>
                  {props.poData.reviewedBy.firstName}
                </span>
              </div>
            )}
            <div className={`${Styles['po-item']}`}>
              <span className={`${Styles['po-label']}`}>Url</span>
              <span className={`${Styles['po-value']}`}>
                <a href={props.poData.url} rel="noopener noreferrer" target="_blank">
                  {`${props.poData.url.substring(0, 40)}...`}
                </a>
              </span>
            </div>
            <div className={`${Styles['po-item']}`}>
              <span className={`${Styles['po-label']}`}>Status</span>
              <span className={`${Styles['po-value']}`}>{props.poData.statusLabel}</span>
            </div>
            <div className={`${Styles['po-item']}`}>
              <span className={`${Styles['po-label']}`}>Filetype</span>
              <span className={`${Styles['po-value']}`}>{props.poData.filetype}</span>
            </div>
            <div className={`${Styles['po-item']}`}>
              <span className={`${Styles['po-label']}`}>Created At</span>
              <span className={`${Styles['po-value']}`}>
                {moment(props.poData.createdAt).format('DD MMMM YYYYY')}
              </span>
            </div>
            <div className={`${Styles['po-item']}`}>
              <span className={`${Styles['po-label']}`}>Updated At</span>
              <span className={`${Styles['po-value']}`}>
                {moment(props.poData.updatedAt).format('DD MMMM YYYY')}
              </span>
            </div>
            {props.poData.status === props.poPendingValue ? (
              <div className={Styles['button-container']}>
                <button
                  className={`${Styles['btn-action']} ${Styles['btn-approve']}`}
                  onClick={props.handleActionPo(
                    props.poData.id,
                    props.poApprovedValue,
                    props.order.id
                  )}
                >
                  Approve
                </button>
                <button
                  className={`${Styles['btn-action']} ${Styles['btn-rejection']}`}
                  onClick={props.handleActionPo(
                    props.poData.id,
                    props.poRejectedValue,
                    props.order.id
                  )}
                >
                  Reject
                </button>
              </div>
            ) : (
              <div />
            )}
          </div>
        ) : (
          <div className={Styles['empty-po']}>
            <span className={Styles['text-empty']}>There is no purchase order yet</span>
          </div>
        )}
      </div>
      <div className={`content ${Styles['border-content']} ${Styles['po-container']}`}>
        <div className={`${Styles['po-title']}`}>
          <h4 className={`${Styles['title-label']}`}>Pay in Amount</h4>
        </div>
        {props.paymentLog.length > 0 ? (
          <div className={Styles.paymentLogTableContainer}>
            <table className={Styles.tablePaymentLog}>
              <tr className={Styles.rowHeader}>
                <th>No. </th>
                <th>Invoice Number </th>
                <th>Payment Date </th>
                <th>Amount </th>
              </tr>
              {props.paymentLog.map((data, index) => (
                <tr key={data.id}>
                  <td>{index + 1}</td>
                  <td>{data.invoiceNumber}</td>
                  <td>{moment(data.createdAt).format('DD MMMM YYYY HH:mm')}</td>
                  <td>{`${props.projectDetail.currency} ${thousandSeparator(
                    data.amount
                  )}`}</td>
                </tr>
              ))}
            </table>
          </div>
        ) : (
          <div className={Styles['empty-po']}>
            <span className={Styles['text-empty']}>There is no payment log yet</span>
          </div>
        )}
      </div>
    </div>
    {props.invoices.length !== 0 ? (
      props.invoices.map(invoice => (
        <div className={`content ${Styles['border-content']} ${Styles['left-content']}`}>
          <div className={Styles['left-content-item']}>
            <Content
              title={`Invoice ${invoice.invoiceNumber}`}
              action={
                invoice.status === props.invoiceStatusWaitingConfirmation
                  ? props.handelActionInvoice
                  : null
              }
              actionParam={
                invoice.status === props.invoiceStatusWaitingConfirmation
                  ? {
                      id: invoice.id,
                      approvedValue: props.invoiceStatusWaitingConfirmed,
                      rejectedValue: props.invoiceStatusRejected,
                      orderId: props.order.id,
                    }
                  : null
              }
              data={Object.entries({
                ...invoice,
                status: invoice.statusLabel,
              }).filter(
                field =>
                  [...props.restrictFields, 'isActive', 'quotation'].indexOf(field[0]) < 0
              )}
            />
          </div>
        </div>
      ))
    ) : (
      <div className={`content ${Styles['border-content']} ${Styles['left-content']}`}>
        <div className={Styles['left-content-item']}>
          <div className={Styles['empty-po']}>
            <span className={Styles['text-empty']}>There is no invoice approval yet</span>
          </div>
        </div>
      </div>
    )}
  </section>
)

TabQuotationPO.propTypes = {
  quotationContent: PropTypes.arrayOf(PropTypes.array).isRequired,
  poData: PropTypes.shape({
    createdAt: PropTypes.string,
    filetype: PropTypes.string,
    submittedBy: PropTypes.shape({
      firstName: PropTypes.string,
    }),
    reviewedBy: PropTypes.shape({
      firstName: PropTypes.string,
    }),
    url: PropTypes.string,
    statusLabel: PropTypes.string,
    updatedAt: PropTypes.string,
    status: PropTypes.number,
    id: PropTypes.string,
  }).isRequired,
  poPendingValue: PropTypes.number.isRequired,
  handleActionPo: PropTypes.func.isRequired,
  poApprovedValue: PropTypes.number.isRequired,
  poRejectedValue: PropTypes.number.isRequired,
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  invoices: PropTypes.arrayOf(PropTypes.object).isRequired,
  paymentLog: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export default TabQuotationPO
